import { HeroVSL } from "@/components/hero/HeroVSL";
import { Footer } from "@/components/Footer";
import FinalCTAVSL from "@/components/FinalCTAVSL";

const Index = () => {
  return (
    <div className="min-h-screen bg-background text-foreground overflow-hidden">
      <HeroVSL />
      <FinalCTAVSL />
      <Footer />
    </div>
  );
};

export default Index;
